import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './ConfigurationPanel.scss';

import ToggleButton from '../../uiElements/ToggleButton';
import ThemedSlider from '../../uiElements/ThemedSlider';

import ThemeContext from '../../../contexts/ThemeContext';

class ConfigurationPanel extends Component {

	static contextType = ThemeContext;

	constructor(props) {
		super(props);
		this.state = {
			isOpen: this.props.isOpen,
			tweetsConfig: this.props.tweetsConfig
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot){
		if( this.props.isOpen !== this.state.isOpen ){
			this.setState({
				isOpen: this.props.isOpen
			})
		}
	}

	setTweetMaxValue = (tweetIndex, newValue) => {
		this.setState({
			tweetsConfig: this.state.tweetsConfig.map((conf, index) => {
				if( index === tweetIndex )
					conf.maxTweets = newValue;

				return conf;
			})
		});
		this.props.onTweetConfigChange(this.state.tweetsConfig);
	};

	setTweetDisplayValue = (tweetIndex, isChecked) => {
		this.setState({
			tweetsConfig: this.state.tweetsConfig.map((conf, index) => {
				if( index === tweetIndex )
					conf.display = isChecked;

				return conf;
			})
		});
		this.props.onTweetConfigChange(this.state.tweetsConfig);
	};

	render(){

		let {tweetsConfig} = this.props;

		return (
			<div className={`configurationPanel ${this.state.isOpen ? 'configurationPanel--open' : ''} ${this.context.isDarkTheme ? 'configurationPanel--dark' : ''}`}>
				<div className="configurationPanelHeader">

				</div>
				<div className="configurationPanelContent">
					<section className="configurationSection">
						<h3 className="configurationSection__title">Toggle dark theme</h3>
						<ToggleButton
							onChange={(isChecked) =>{
								this.props.onDarkThemeToggle(isChecked);
							}}
							defaultChecked={this.context.isDarkTheme}
						/>
					</section>
					<section className="configurationSection">
						<h3 className="configurationSection__title">Configuration</h3>
						{
							tweetsConfig.map((tweetConf, index) => {
								return (
									<div key={index} className="configurationOption">
										<h4 className="configurationOption__feedName">
											@{tweetConf.twitterUser}
										</h4>
										<span className="configurationOption__title">
											Max tweets:
										</span>
										<ThemedSlider
											min={5}
											max={40}
											value={tweetConf.maxTweets}
											onChange={this.setTweetMaxValue.bind(this, index)}
										/>
										<span className="configurationOption__title">
											Toggle display:
										</span>
										<ToggleButton
											onChange={this.setTweetDisplayValue.bind(this, index)}
											defaultChecked={tweetConf.display}
										/>
									</div>

								)
							})
						}
					</section>
				</div>
			</div>
		)
	}
}

ConfigurationPanel.propTypes = {
	isOpen: 				PropTypes.bool.isRequired,
	onDarkThemeToggle: 		PropTypes.func.isRequired,
	tweetsConfig:			PropTypes.array.isRequired,
	onTweetConfigChange:	PropTypes.func.isRequired
};

export default ConfigurationPanel;